import React, {Component} from 'react';
// import './css/terms_condition.css';
import './css/styles.css';
class Terms_condition extends React.Component{
    render(){
        return(   
            <div>
                <div class="container"  style={{padding:'20px',paddingTop:'80px'}} >
    <h3>AiPlex Terms and Conditions</h3>
    <p>
        These Terms and Conditions govern your use, and apply to the entire contents of, 
        AiPlex websites and services on aiplex.com and its sub-domains, including but not
         limited to the data or other results 
        obtained using services or tools made available thereon (collectively, the “Website”).
    </p>
    <p>
        These Terms and Conditions shall also apply to any services AiPlex may agree to
         provide to you if these Terms and Conditions are referenced in a written agreement
          or statement of work regarding such services. Please read these Terms and 
          Conditions carefully before using this Website or agreeing to any services. 
          By accessing, browsing, or using our Website or any links, services, or tools 
          through our Website or otherwise offered by AiPlex in any agreement or statement 
          of work referencing these Terms and Conditions, you are agreeing to all of these 
          Terms and Conditions in their entirety.
    </p>
    <p>
        This website describes how we collect and use your personal information and the
         rights you have in relation to that information. AiPlex is the data controller
          of any personal data you provide to us, including in relation to this website 
          <a href="https://aiplex.com/" target="_blanck">(https://aiplex.com/)</a> 
    </p>
    <h5>1. General</h5>
    <p>This Website is owned and operated by AiPlex; a Bangalore based Pvt. Ltd. company.
          Unless indicated otherwise, we use the terms “AiPlex”, “we” and “us” on this Website
          in these Terms and Conditions and other posted policies to refer to AiPlex.
    </p>
    <h5>2. Changes</h5>
    <p>
        We reserve the unilateral right to change these Terms and Conditions, 
        in whole or in part, at any time. Any such changes will take effect immediately when
         posted on the Website. You should check this page regularly to take notice of any
          changes we may have made to the Terms and Conditions.
    </p>
    <h5>3. Intellectual Property</h5>
    <p>
        3.1 Unless expressly stated otherwise on the Website, you should assume that all
         content, images, and materials appearing on or available through the Website or
          otherwise provided to you by AiPlex (collectively the “Content”) are and shall
           remain the sole property of AiPlex and/or its licensors. You may not use, 
           reproduce, display, or sell any Content without our prior written consent.
            You may not use any Content without our prior written consent.
    </p>
    <p>
        3.2 You acknowledge and agree that the Content is made available for your personal
         non-commercial use only and that you may only download such Content for the purpose 
         of using this Website. You also acknowledge that any other use of the Content is 
         strictly prohibited and you agree not to (and agree not to facilitate or assist any
          third party to) copy, reproduce, transmit, publish, display, distribute, commercially 
          exploit, or create derivative works of such Content.
    </p>
    <p>
        3.3 The trademarks, logos, and service marks displayed on the Website belong to 
        AiPlex Software Pvt Ltd and/or our affiliates or third parties which have licensed
         those rights to AiPlex; You may not use, reproduce, or display any AiPlex without 
         their respective owner’s prior written consent. All other trademarks, product names, 
         and company names and logos appearing on the Website are the property of their
          respective owners.
    </p>
    <h5>4. Restrictions on Use</h5>
    <p>You are specifically restricted from all the following:</p>
    <ol>
        <li>Publishing, selling, sub-licensing and/or otherwise commercializing any Content</li>
        <li>Using this Website in any way that is or may be damaging to this Website</li>
        <li>Using this Website in any way that impacts user access to this Website,
             or which otherwise imposes an unreasonable or disproportionately large
              load on the AiPlex Software Pvt. Ltd. infrastructure</li>
        <li>Using this Website or any service or deliverables provided to you by AiPlex 
            Software Pvt. Ltd. contrary to applicable laws and regulations or these Terms
             and Conditions, or in any way that may cause harm to AiPlex Software Pvt. 
             Ltd or to any person or business entity</li>
        <li>Engaging in any data mining, data harvesting, data extracting, or any other similar activity in relation to this
            Website</li>
        <li>
             Using any robot, spider, or other automated device, process, or means to access this Website
        </li>
        <li>
             Entering or uploading any data or using any services available through this 
             Website without the authorization of the owner of any related intellectual 
             property or other rights relating to such use, including but not limited to
              domain name, e-mail, or privacy rights
        </li>
        <li>
             Incorporating any portions of this Website or any related services,
             including data obtaining using such services, into your own website
        </li>
        <li>
            Using this Website to engage in any advertising or marketing.
        </li>
    </ol>
    <p>Certain areas of this Website are restricted from being accessed by you.</p>
    <p>
        <strong>AiPlex Software Pvt. Ltd.</strong> may further restrict access by you to this Website,
         in part or in whole, at any time, in its sole and absolute discretion.
    </p>
    <h5>5. No Warranties</h5>
    <p>
        This website, including but not limited to any tools, services, or information that 
        you may access through the website, and any services and deliverables provided to
         you by AiPlex Software Pvt. Ltd. pursuant to a written agreement or statement of
          work referencing these terms and conditions are provided as-is. 
          AiPlex Software Pvt Ltd does not make any warranties, express or implied, 
          with respect to any content or any tools provided on or through the website or 
        with respect to any services or deliverables provided to you by 
        AiPlex Software Pvt. Ltd pursuant to a written agreement or statement of work 
        referencing these terms and conditions.
    </p>
    <p>
        We hereby expressly disclaim any and all implied warranties, including without 
        limitation any warranties of merchantability or fitness for a particular purpose. 
        We do not guarantee that any content, information, or other material accessible 
        through the website will be free of viruses, “worms”, “trojan horses”, or other 
        harmful components.
    </p>
    <h5>6. Limited Liability</h5>
    <p>
        We do not accept, and hereby exclude to the fullest extent permissible under
         applicable law, any liability for any loss of data, profit, revenue, or 
         business or for any indirect or consequential loss or damage however caused.
    </p>
    <h5>7. Your Indemnification of AiPlex Software Pvt Ltd</h5>
    <p>
        You agree that you shall fully defend and indemnify AiPlex Software Pvt Ltd, its
        subsidiaries and affiliated companies and their respective officers, directors, owners, agents, attorneys,
        shareholders, related entities, heirs, and assigns, from and against any and all claims, demands, actions, suits,
        losses, liabilities, damages, injuries, fines penalties, costs and expenses, attorneys’ fees, arbitration fees,
        mediation fees, expert expenses, and all other consequences of every kind, directly or indirectly resulting from any
        and all failure(s) of you or your agent(s) to fully comply with all duties, obligations, and other provisions set
        forth in this Agreement, including, but not limited to, your warranties or your violation of a third party’s
        intellectual property rights.
    </p>
    <p>
        You further agree to defend, indemnify, and hold harmless AiPlex Software Pvt Ltd, its subsidiaries and affiliated
        companies and their respective its officers, directors, owners, agents, attorneys, shareholders, related entities,
        heirs, and assigns, from and against any and all claims, demands, actions, suits, loses, liabilities, damages,
        injuries, fines, penalties, costs and expenses, including, without limitation, reasonable attorneys’ fees, arising
        out of any property damage or recoverable economic loss incurred by a third party, to the extent such damage or loss
        is caused by any act or omission of you or your agents in connection with the performance of these Terms and
        Conditions or any written agreement or statement of work referencing these Terms and Conditions.
    </p>
    <p>
        You agree that AiPlex Software Pvt Ltd shall have the right to participate in the defense of any such claim through
        counsel of its own choosing at your expense.
    </p>
    <h5>8. Governing Law and Dispute Resolution</h5>
    <p>
        8.1 The Terms and Conditions, and any written agreement or statement of work referencing these Terms and Conditions,
        shall be governed exclusively by and interpreted in accordance with the laws of the Bangalore Jurisdiction.
    </p>
    <h5>9. Miscellaneous Provisions</h5>
    <p>9.1 All contracts shall be concluded in English.</p>
    <p>9.2 If any of these Terms and Conditions are found to be illegal, invalid, or unenforceable by any court of competent
        jurisdiction, the rest of these Terms and Conditions shall remain in full force and effect.</p>
    <p>9.3 Neither these Terms and Conditions, nor any written agreement or statement of work referencing these Terms and
        Conditions, and the rights pertaining hereto and thereto may not be assigned, resold, or otherwise transferred in
        whole or in part by you without our prior written consent, which may be withheld for any or no reason.
        Notwithstanding the above, these Terms and Conditions and any written agreement or statement of work referencing
        these Terms and Conditions shall be binding upon your successors and assigns, if any. We may assign or license any
        or all of our rights and/or obligations hereunder or thereunder in our free, sole, and unfettered discretion.</p>
    <p>9.4 We will not be responsible to you for any delay or failure to comply with our obligations under these Terms and
        Conditions or any written agreement or statement of work referencing these Terms and Conditions if the delay or
        failure arises from any cause beyond our reasonable control.</p>
    <p>9.5 If you breach these Terms and Conditions or any written agreement or statement of work referencing these Terms
        and Conditions and we take no action; we will still be entitled to use our rights and remedies in other situations
        where you are in breach.</p>
    <p>.6 This Website also contains links to other websites, which are not operated by AiPlex Software Pvt Ltd (the “Linked
        Sites”). AiPlex Software Pvt Ltd has no control over the Linked Sites and accepts no responsibility for them or for
        any loss or damage that may arise from your use of them. Your use of the Linked Sites is at your own risk and will
        be subject to the terms of use and service contained within each such site, if any.</p>
    <p>9.7 We use reasonable efforts to ensure that our Website is free from viruses and other malicious or harmful content.
        However, we cannot guarantee that your use of this Website (including any content on it or any website accessible
        from it) will not cause damage to your computer or other device. It is your responsibility to ensure that you have
        the right equipment (including anti-virus software) to use this Website safely. Except as may be required by
        applicable law, AiPlex Software Pvt Ltd shall not be liable to any person for any loss or damage they suffer as a
        result of viruses or other malicious or harmful content that they access from or via our Website.</p>
    <p>9.8 We endeavor to ensure that the Website remains available at all times. However, we cannot guarantee that the
        Website will operate continuously. We therefore cannot accept any liability for any failure or non-availability of
        the Website.</p>
    <p>9.9 Nothing in these Terms and Conditions or any written agreement of statement of work referencing these Terms and
        Conditions is intended to create or constitute an agency, joint or collaborative venture, or partnership of any kind
        between AiPlex Software Pvt Ltd and you, nor shall anything in these Terms and Conditions or any written agreement
        of statement of work referencing these Terms and Conditions be construed as constituting or creating any such
        agency, joint or collaborative venture, or partnership between AiPlex Software Pvt Ltd and you.</p>
    <p>9.10 Please review our other policies posted on this site. These policies also govern your visit to the Website.</p>
    <p>9.11 These Terms and Conditions, along with any written agreement or statement of work referencing these Terms and
        Conditions, constitutes the entire agreement with respect to the subject matter hereof, and supersedes and cancels
        all other prior agreements, discussion, or representations, whether written or oral between us and you related to
        the subject matter hereof. No officer, employee or representative of AiPlex Software Pvt Ltd or you has any
        authority to make any representation or promise in connection with these Terms and Conditions or the subject matter
        thereof which is not contained expressly in this these Terms and Conditions, and we and you hereby acknowledge and
        agree that neither we nor you have entered into these Terms and Conditions in reliance upon any such representation
        or promise.</p>
</div>
            </div>
             )
    }
}
export default Terms_condition